import { createContext, useContext } from "react";
import type { HeadsUpSidebarModel } from "@/components/heads-up/sidebar/types/heads-up-sidebar.types";

export const HeadsUpContext = createContext<HeadsUpSidebarModel | null>(null);

export function useHeadsUpContext(): HeadsUpSidebarModel {
  const context = useContext(HeadsUpContext);
  if (!context) {
    throw new Error("useHeadsUpContext must be used within a HeadsUpContextProvider");
  }
  return context;
}

export function useHeadsUpClick() {
  return useHeadsUpContext().interactions.clickHandlers;
}

export function useHeadsUpViewState() {
  return useHeadsUpContext().content.viewState;
}
